import { orderBy } from 'lodash';
import { ESignConstants, TaskConstants } from '../../../constants';
import { checkDocuments, checkESignStatus, getTaskStatus } from './CommonUtils';
const createESignTask = (loanPackages, isOtherBorrowerPending, otherBorrowerName) => {
  const finalESignData = [];
  const {
    HEADING_TASK_NAME,
    HEADING_TASK_DESCRIPTION
  } = ESignConstants;
  const {
    TASK_TYPE_SIGN_DISCLOSURES
  } = TaskConstants;
  loanPackages.map(item => {
    const {
      discloseDate,
      name,
      signingFlag,
      jointBorrowerPackage
    } = item;
    const esignObj = {
      name: HEADING_TASK_NAME,
      taskStatus: checkESignStatus(item),
      priority: '1',
      details: HEADING_TASK_DESCRIPTION,
      completionDate: discloseDate,
      documentList: '',
      taskType: TASK_TYPE_SIGN_DISCLOSURES,
      data: item,
      borrowerName: name,
      signingFlag: signingFlag,
      jointBorrowerPackage: jointBorrowerPackage,
      isWaitingforBorrowerESign: isOtherBorrowerPending,
      nonEsignedBorrowerNames: otherBorrowerName,
      docURL: item?.docURL
    };
    finalESignData.push(esignObj);
  });
  return finalESignData;
};
export const createTrackingItemTask = (documentResponse, historyData) => {
  if (documentResponse !== undefined && documentResponse.length > 0) {
    const doc = documentResponse?.map(item => {
      const {
        name,
        status,
        details,
        trackingDate,
        trackingItemName,
        borrowerName
      } = item;
      const data = {
        name: name,
        taskStatus: getTaskStatus(status),
        priority: '2',
        details: details,
        completionDate: trackingDate,
        documentList: checkDocuments(name, historyData),
        taskType: TaskConstants.TASK_TYPE_TRACKING_ITEM,
        data: item,
        borrowerName: borrowerName ? borrowerName : 'All Borrowers',
        trackingItemName: trackingItemName,
        status
      };
      return data;
    });
    return doc;
  }
};
const currentUserLoanPackages = packages => {
  const currentUserESignPackages = [];
  packages.map(item => {
    if (item.signingFlag || item.jointBorrowerPackage) currentUserESignPackages.push(item);
  });
  return currentUserESignPackages;
};
export const prepareTaskData = (trackingAPIResponse, esignData) => {
  const data = [];
  const esignResponse = [];
  esignResponse.push(esignData);

  //Flatting esign data
  const flatEsign = esignResponse?.flatMap(list => list?.loanPackages || []);
  //Getting current user packages, This may contain jointBorrower esign packages
  const currentUserPackages = currentUserLoanPackages(flatEsign);

  //if there are more package available then its non-joint borrower packages
  if (flatEsign.length > currentUserPackages.length) {
    //get non-jointCoBorrowers who has not esigned
    const nonEsignedBorrowers = flatEsign?.filter(item => !item?.signed && !item?.jointBorrowerPackage && !item?.signingFlag);
    //create esign task for current user packages but with waiting for other borrower
    data.push(...createESignTask(currentUserPackages.filter(item => item?.signed), nonEsignedBorrowers.length > 0, nonEsignedBorrowers.map(item => item?.name).join(', \n')));
    data.push(...createESignTask(currentUserPackages.filter(item => !item?.signed), false, ''));
  } else {
    data.push(...createESignTask(currentUserPackages, false, ''));
  }

  //create document obj for tasks
  const documents = createTrackingItemTask(trackingAPIResponse?.documentsData, trackingAPIResponse?.historyData);
  documents ? data.push(...documents) : [];
  const {
    TASK_OTHER_NAME,
    TASK_OTHER_DESCRIPTION,
    TASK_TYPE_TRACKING_ITEM,
    ADDITIONAL_DOC
  } = TaskConstants;
  //check otherDocuments for tasks
  const otherDocumentTask = {
    name: TASK_OTHER_NAME,
    taskStatus: '',
    priority: '99',
    details: TASK_OTHER_DESCRIPTION,
    completionDate: '',
    documentList: checkDocuments(TASK_OTHER_NAME, trackingAPIResponse?.historyData),
    taskType: TASK_TYPE_TRACKING_ITEM,
    data: {},
    borrowerName: 'All Borrowers',
    trackingItemName: ADDITIONAL_DOC
  };
  data.push(otherDocumentTask);
  return orderBy(data, [`taskStatus`], [`desc`]);
};
//# sourceMappingURL=index.js.map